const APARTMENT_RING_TYPES = [
  { text: 'По умолчанию', value: 0 },
  { text: 'К Элизе', value: 1 },
  { text: 'Тишина', value: 2 },
  { text: 'На прекрасном голубом Дунае', value: 3 },
];

const APARTMENT_RING_VOLUMES = [
  { text: 'Выкл (0%)', value: 0 },
  { text: '15%', value: 1 },
  { text: '30%', value: 2 },
  { text: '45%', value: 3 },
  { text: '60%', value: 4 },
  { text: '75%', value: 5 },
  { text: '100%', value: 6 },
];

function unwrapApartmentAnalogSettings (payload) {
  if (payload?.data != null && payload.apartment == null && payload.ring_type == null) {
    return payload.data;
  }
  return payload;
}

function mapApartmentAnalogFormFromApi (data, apartmentFallback) {
  return {
    apartment: Number(data.apartment ?? apartmentFallback),
    ring_type: Number(data.ring_type),
    ring_volume: Number(data.ring_volume),
    analog_line_voltage_idle: data.analog_line_voltage_idle,
    analog_line_voltage_lifted: data.analog_line_voltage_lifted,
    analog_line_voltage_button_pressed: data.analog_line_voltage_button_pressed,
    digital_line_voltage_lifted: data.digital_line_voltage_lifted,
    audio_volume: Number(data.audio_volume),
    audio_mic: Number(data.audio_mic),
    handset_proxy_volume: Number(data.handset_proxy_volume),
  };
}

export {
  APARTMENT_RING_TYPES,
  APARTMENT_RING_VOLUMES,
  unwrapApartmentAnalogSettings,
  mapApartmentAnalogFormFromApi,
};
